export const critiqueManagerOptions = [
  { value: 1, label: "Auto Approve" },
  { value: 2, label: "Manual Approve" },
];